var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Target icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 215.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.95,179.99c-39.76,0-72.03-32.22-72.03-71.99S68.19,35.97,107.95,35.97s72.03,32.19,72.03,72.04c0,39.77-32.23,71.99-72.03,71.99M107.95,0C48.34,0,0,48.35,0,108.01s48.34,107.94,107.95,107.94,108.05-48.34,108.05-107.94S167.59,0,107.95,0Z",
    fill: "#c00",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.97,70.97c-20.43,0-36.99,16.52-36.99,37.01s16.56,36.99,36.99,36.99,37.04-16.57,37.04-36.99-16.59-37.01-37.04-37.01",
    fill: "#c00",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/Icon-Target.ec9fa382fd6907a7ad3de2af1b8a395d.svg";
export { ForwardRef as ReactComponent };